import { useState, useEffect } from "react";
import Dialog from "../../../designSystem/c-organism/dialogs/Dialog";
import Input from "../../../designSystem/b-molecules/formElements/input/Input";
import Button from "../../../designSystem/b-molecules/buttons/Button";
import { ref, update } from "firebase/database";
import { db } from "../../../configs/Firebase";
import { isValidFigmaUrl } from "../utils/figmaUtils";
import style from "./FigmaUrlEditor.module.css";

const FigmaUrlEditor = ({
  show,
  onClose,
  onSave,
  initialUrl,
  journeyRefURL,
  rowId,
  cellIndex,
}) => {
  const [url, setUrl] = useState(initialUrl || "");
  const [error, setError] = useState("");

  useEffect(() => {
    setUrl(initialUrl || "");
    setError("");
  }, [initialUrl, show]);

  function handleUrlChange(e) {
    const newUrl = e.target.value;
    setUrl(newUrl);
    setError("");
  }

  function handleSave() {
    const trimmedUrl = url.trim();
    
    if (!trimmedUrl) {
      // Allow empty URL to clear the value
      saveUrl("");
      return;
    }

    if (!isValidFigmaUrl(trimmedUrl)) {
      setError("Please enter a valid Figma URL (must be https:// and contain figma.com)");
      return;
    }

    saveUrl(trimmedUrl);
  }

  function saveUrl(urlToSave) {
    if (journeyRefURL && rowId !== undefined && cellIndex !== undefined) {
      update(ref(db), {
        [journeyRefURL +
        "/rows/" +
        rowId +
        "/columns/" +
        cellIndex +
        "/value"]: urlToSave,
      });
    }
    
    if (onSave) {
      onSave(urlToSave);
    }
    
    onClose();
  }


  return (
    <Dialog show={show} title="Add Figma URL" onClose={onClose} variants={["large"]}>
      <div className={style.editor}>
        <Input
          label="Figma URL"
          placeholder="https://www.figma.com/file/..."
          value={url}
          onChange={handleUrlChange}
          error={error}
        />
        <div className={style.helper}>
          <p>Enter a Figma file or frame URL to embed it in this cell.</p>
        </div>
        <div className={style.actions}>
          <Button variants={["text"]} onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleSave}>
            Save
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default FigmaUrlEditor;
